var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsInactive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.417 6.75H12v1.167h6.417a.583.583 0 0 0 0-1.167M5.583 7.917H8.5v.75a1 1 0 0 0 1 1h.333a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v.75H5.583a.583.583 0 0 0 0 1.167m12.834 8.166H12v1.167h6.417a.583.583 0 1 0 0-1.167M5.583 17.25H8.5V18a1 1 0 0 0 1 1h.333a1 1 0 0 0 1-1v-2.5a1.167 1.167 0 0 0-2.333 0v.583H5.583a.583.583 0 1 0 0 1.167m12.834-5.833h-1.75v1.166h1.75a.583.583 0 1 0 0-1.166M5.583 12.583h7.584v.75a1 1 0 0 0 1 1h.333a1 1 0 0 0 1-1v-2.666a1 1 0 0 0-1-1h-.333a1 1 0 0 0-1 1v.75H5.583a.583.583 0 0 0 0 1.166"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings-inactive.6add5bbb.svg";